import { render, staticRenderFns } from "./recMission.vue?vue&type=template&id=35b6a624&"
import script from "./recMission.vue?vue&type=script&lang=js&"
export * from "./recMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports